import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';

@Component({
  selector: 'lib-qr-help-modal',
  templateUrl: './qr-help-modal.component.html',
  styleUrls: ['./qr-help-modal.component.scss'],
  imports: [IonContent, IonTitle, IonIcon, IonButton, IonButtons, IonToolbar, IonHeader],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QrHelpModalComponent {
  private readonly modalCtrl = inject(ModalController);

  protected async closeModalWithCancel(): Promise<boolean> {
    return this.modalCtrl.dismiss(null, 'cancel');
  }
}
